import { render, staticRenderFns } from "./items-dialog.vue?vue&type=template&id=2adccf56&scoped=true&"
import script from "./items-dialog.vue?vue&type=script&lang=js&"
export * from "./items-dialog.vue?vue&type=script&lang=js&"
import style0 from "./items-dialog.vue?vue&type=style&index=0&id=2adccf56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adccf56",
  null
  
)

export default component.exports